import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import config from 'config';

const API_URL = config.API_URL;

export const linkedinkServices = createApi({
    reducerPath: 'linkedinkServices',
    refetchOnFocus: false,

    baseQuery: fetchBaseQuery({
        baseUrl: API_URL,
        prepareHeaders: (headers, { getState }) => {
            headers.set('Content-Type', 'application/json');
            return headers;
        },
        credentials: 'include',
    }),

    tagTypes: ['posts'],

    endpoints: (builder) => ({
        getPost: builder.query<any, any>({
            query: (params) =>
                `${API_URL}/linkedin/posts?items=${params.items}&offset=${params.offset}`,
            providesTags: ['posts'],
        }),
    }),
});

export const { useGetPostQuery } = linkedinkServices;
